module.exports = "/images/logo.06b772379b1f5284ef27981cbdf84c44.svg";